import React from 'react'
import Image from '../general/Image'
import { Link } from 'react-router-dom'
import Facebook from '../../assets/common/facebook.png'
import Instagram from '../../assets/common/instagram.png'
import Twitter from '../../assets/common/twitter.png'
import LinkedIn from '../../assets/common/in.png'
import Button from '../general/Button'
import { ROUTES } from '../../routes/RouteList'

const Footer = () => {
    return (
        <footer className="-mt-[47px]">
            <div className='bg-black'>
                <div className="--layout-padding max-width text-white !pt-[45px] md:!pt-[80px] lg:!pt-[100px] !pb-[30px] lg:!pb-[60px] grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-y-[30px]">
                    <div>
                        <p className='text-[20px] font-semibold'>Company</p>
                        <ul className='flex flex-col gap-[4px] mt-[10px] lg:gap-[10px]'>
                            <li className='text-[14px] font-light'>
                                <Link to={ROUTES.ABOUT_US}>About Us</Link>
                            </li>
                            <li className='text-[14px] font-light'>For Developers</li>
                            <li className='text-[14px] font-light'>Careers</li>
                        </ul>
                    </div>

                    <div>
                        <p className='text-[20px] font-semibold'>Community</p>
                        <ul className='flex flex-col gap-[4px] mt-[10px] lg:gap-[10px]'>
                            <li className='text-[14px] font-light'>Blog</li>
                            <li className='text-[14px] font-light'>Events</li>
                        </ul>
                    </div>
                    <div>
                        <p className='text-[20px] font-semibold'>Resources</p>
                        <ul className='flex flex-col gap-[4px] mt-[10px] lg:gap-[10px]'>
                            <li className='text-[14px] font-light'>FAQ for companies</li>
                            <li className='text-[14px] font-light'>FAQ for developers</li>
                            <li className='text-[14px] font-light'>Case Studies</li>
                            <li className='text-[14px] font-light'>Questions & Answers</li>
                        </ul>
                    </div>
                    <div>
                        <p className='text-[20px] font-semibold'>Terms</p>
                        <ul className='flex flex-col gap-[4px] mt-[10px] lg:gap-[10px]'>
                            <li className='text-[14px] font-light'>Terms of Service</li>
                            <li className='text-[14px] font-light'>Privacy Policy</li>
                        </ul>
                    </div>

                    <div className='col-span-2 lg:col-span-2'>
                        <p className='text-primary-color text-right'>Or you can say hi to our email:</p>
                        <Link className='text-[1.5rem] font-semibold lg:text-[1.6rem] text-right block' to="mailto:work@devhire.com">work@devhire.com</Link>
                    </div>

                    <div className='flex justify-start items-center gap-[10px] col-span-2 md:col-span-3 lg:col-span-5 lg:mt-[20px]'>
                        <Link to="https://www.facebook.com/devhire.com">
                            <Image src={LinkedIn} alt="linkedin" />
                        </Link>
                        <Link to="https://www.facebook.com/devhire.com">
                            <Image src={Instagram} alt="instagram" />
                        </Link>
                        <Link to="https://www.facebook.com/devhire.com">
                            <Image src={Twitter} alt="twitter" />
                        </Link>
                        <Link to="https://www.facebook.com/devhire.com">
                            <Image src={Facebook} alt="facebook" />
                        </Link>
                    </div>

                    <Button onClick={() => {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                            duration: 1000
                        })
                    }} className="bg-primary-color text-black rounded col-span-2 h-[40px] lg:h-[50px] md:col-span-1 lg:mt-[20px] flex items-center justify-center gap-[10px] text-[0.8rem]"> 
                        Back to top 
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 text-black">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
                        </svg>
                    </Button>
                </div>
            </div>

            <div className="bg-white !py-[8px] --layout-padding max-width">
                <div className="flex items-center gap-[10px]">
                    <p>Copyright © {new Date().getFullYear()}, </p>
                    <Image className="w-[100px]" src="/images/footer-logo.png" alt="logo" />
                </div>
            </div>
        </footer>

    )
}

export default Footer